const INITIAL_STATE = {
	aguardando: false,
	registro: [],
	modoTela: 'lista',
	lista: [],
	listaLog: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CONTROLE_INTEGRACAO_TMS_WEBCOL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'CONTROLE_INTEGRACAO_TMS_WEBCOL_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'CONTROLE_INTEGRACAO_TMS_WEBCOL_LOG_LISTADO':
            return {
				...state,
				listaLog: action.payload.data
			};

		case 'CONTROLE_INTEGRACAO_TMS_WEBCOL_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        default:
            return state;
    }
}
